import {hexToRgba} from '@edna/utils';

import {DEFAULT_PALETTE} from './defaultPalette';

export type TBoxShadow = {
  default: string;
  listHead: string;
  input: string;
  button: string;
  dropdown: string;
  notification: string;
  modal: string;
  widget: string;
  XS?: string;
  S?: string;
  M?: string;
  L?: string;
  XL?: string;
};

export type TBoxShadowOptions = Partial<TBoxShadow>;

export const DEFAULT_BOX_SHADOW = {
  default: `0 1px 4px -1px ${hexToRgba(DEFAULT_PALETTE.grey900, 0.2)}`,
  listHead: `0 4px 4px -4px ${hexToRgba(DEFAULT_PALETTE.black, 0.2)}`,
  input: 'none',
  button: `2px -2px 6px -2px ${hexToRgba(DEFAULT_PALETTE.grey900, 0.1)}, 0 6px 2px -4px ${hexToRgba(
    DEFAULT_PALETTE.grey900,
    0.1,
  )}`,
  dropdown: `0 1px 4px -1px ${hexToRgba(DEFAULT_PALETTE.grey900, 0.2)}`,
  notification: `0 1px 4px ${hexToRgba(DEFAULT_PALETTE.black, 0.28)}`,
  modal: `0 12px 48px -6px ${hexToRgba(DEFAULT_PALETTE.grey900, 0.38)}, 0 3px 18px -2px ${hexToRgba(
    DEFAULT_PALETTE.grey900,
    0.16,
  )}`,
  widget: `0 3px 12px -1px ${hexToRgba(DEFAULT_PALETTE.grey900, 0.26)}, 0 2px 4px -1px ${hexToRgba(
    DEFAULT_PALETTE.grey900,
    0.16,
  )}`,
  XS: `0 1px 4px -1px ${hexToRgba(DEFAULT_PALETTE.grey900, 0.2)}`,
  S: `0 2px 4px -1px ${hexToRgba(DEFAULT_PALETTE.grey900, 0.16)}, 0 3px 12px -1px ${hexToRgba(
    DEFAULT_PALETTE.grey900,
    0.26,
  )}`,
  M: `0 2px 6px -1px ${hexToRgba(DEFAULT_PALETTE.grey900, 0.16)}, 0 8px 24px -4px ${hexToRgba(
    DEFAULT_PALETTE.grey900,
    0.38,
  )}`,
  L: `0 3px 18px -2px ${hexToRgba(DEFAULT_PALETTE.grey900, 0.16)}, 0 12px 48px -6px ${hexToRgba(
    DEFAULT_PALETTE.grey900,
    0.38,
  )}`,
  XL: `0 12px 48px -6px ${hexToRgba(DEFAULT_PALETTE.grey900, 0.38)}, 0 3px 18px -2px ${hexToRgba(
    DEFAULT_PALETTE.grey900,
    0.16,
  )}`,
};

export const createBoxShadow = (customBoxShadow?: TBoxShadowOptions): TBoxShadow => {
  return {
    ...DEFAULT_BOX_SHADOW,
    ...customBoxShadow,
  };
};
